module.exports = __webpack_public_path__ + "img/dvojpomniky.bfa7f42e.jpg";